import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

// COMPONENTS
import Connectivity from './cards/connectivity.component';
import { CanOrNotFound } from 'permissions';

// STYLES
import { SettingsPageContent } from 'styles/settings';

// CONSTANTS
import { DotAppRoute, FleetSettingsSideMenuItem, UserPermission } from 'constants/common';

const Vehicles = () => {
  const intl = useIntl();

  return (
    <CanOrNotFound I={UserPermission.VIEW} a={DotAppRoute.SETTINGS} field={FleetSettingsSideMenuItem.VEHICLES}>
      <SettingsPageContent>
        <Helmet>
          <title>
            {intl.formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            content={intl.formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>
        <Connectivity />
      </SettingsPageContent>
    </CanOrNotFound>
  );
};

export default Vehicles;
